import type { TabContentProps } from '~/app/components/knowledgeBase/componentSchemaManager/ComponentSchemaManager.types';
import { TabContent } from './TabContent';

export const TabContentContainer = (props: TabContentProps) => {
  const {
    config,
    viewMode,
    onToggleView,
    lookupData,
    editingRows,
    onAddRow,
    onEditRow,
    onDeleteRow,
    onSaveRow,
    onCancelEdit,
    onApplySynonyms,
    onRefresh,
    search,
    onSearch,
    onMatchySubmit,
    associationCounts,
    associationCountsSecondary,
    associationLabelSecondary,
    onOpenTransfer,
    onOpenTransferSecondary,
    pagination,
    onPageChange,
  } = props;

  // Primary association counts for Asset Type / Subsystem are already rendered
  // via associatedSubsystemsCount / associatedAssetTypesCount columns.
  // Only secondary associations (e.g. Subsystem → Component Classes) use this path.
  const associationLabel = undefined;

  // Safe local aliases to avoid accidental global/reference errors in compiled bundles
  const assocCountsSecondaryLocal = associationCountsSecondary ?? undefined;
  const assocLabelSecondaryLocal = associationLabelSecondary ?? undefined;
  const onOpenTransferSecondaryLocal = onOpenTransferSecondary ?? undefined;

  return (
    <TabContent
      config={config}
      viewMode={viewMode}
      onToggleView={onToggleView}
      lookupData={lookupData}
      editingRows={editingRows}
      onAddRow={onAddRow}
      onEditRow={onEditRow}
      onDeleteRow={onDeleteRow}
      onSaveRow={onSaveRow}
      onCancelEdit={onCancelEdit}
      onApplySynonyms={onApplySynonyms}
      onRefresh={onRefresh}
      search={search}
      onSearch={onSearch}
      onMatchySubmit={onMatchySubmit}
      associationCounts={associationCounts}
      associationLabel={associationLabel}
      associationCountsSecondary={assocCountsSecondaryLocal}
      associationLabelSecondary={assocLabelSecondaryLocal}
      onOpenTransfer={onOpenTransfer}
      onOpenTransferSecondary={onOpenTransferSecondaryLocal}
      pagination={pagination}
      onPageChange={onPageChange}
    />
  );
};
